import React from "react";
import styled from "styled-components";
import InfoToolTip from "js/react/components/InfoToolTip";
import { Gap10, Gap5 } from "js/react/components/Gap";
import { Icon } from "@material-ui/core";

export const SimpleLabelContainer = styled.label`
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;
  font-weight: 600;
  margin: 12px 0px;
  text-transform: uppercase;
    
    .popupmenu-icon {
        font-size: 16px;
    }
`;

export function SimpleLabel({ children, tooltip }) {
    return (
        <SimpleLabelContainer>
            {children}
            {tooltip &&
                <>
                    <Gap10/>
                    <InfoToolTip title={tooltip} />
                </>
            }
        </SimpleLabelContainer>
    );
}

const WarningLabelContainer = styled.div`
    display: flex;
    align-items: center;
    font-size: 14px;
    color: orangered;
    font-weight: 600;
    margin: 12px 0px;
`;

export function WarningLabel({ children, showIcon = true, tooltip }) {
    return (
        <WarningLabelContainer>
            {showIcon && <Icon>warning</Icon>}
            {showIcon && <Gap10/>}
            {children}
            {tooltip &&
                <>
                    <Gap10/>
                    <InfoToolTip title={tooltip} />
                </>
            }
        </WarningLabelContainer>
    );
}

